import { ICartItem } from '@shared/data-access/interfaces';

export class SddFulfillmentMethodModel {
  public allItemsSamedayable: boolean;
  public cartContainsSameDay: boolean;
  public sddExclusive: boolean;
  public sameDayCartItems: ICartItem[];

  constructor(args: Partial<SddFulfillmentMethodModel> = {}) {
    this.allItemsSamedayable = args.allItemsSamedayable || false;
    this.cartContainsSameDay = args.cartContainsSameDay || false;
    this.sddExclusive = args.sddExclusive || false;
    this.sameDayCartItems = args.sameDayCartItems || [];
  }
}
